import {Toaster} from 'sonner';

/**
 * Sonner-toast как отдельный провайдер по эталону 008
 * (`app/providers/ToastProvider.tsx`). Монтируется один раз на корне приложения,
 * `<Toaster />` сам отдаёт portal-якорь поверх всего UI; `position` и стиль
 * заданы централизованно, чтобы фичам не приходилось их повторять.
 */
export const ToastProvider = () => (
  <Toaster position='top-right' richColors closeButton />
);
